<template>
  <div class="storyThumb">
    <div class="circle">
      <img :src="props.user.profile" alt="" />
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        style="enable-background: new -580 439 577.9 194"
        xml:space="preserve"
      >
        <circle cx="50" cy="50" r="40" />
      </svg>
    </div>
    <div class="storyDesc">
      {{ props.user.desc }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StoryThumb",
};
</script>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
  user: {
    type: {
      name: String,
      profile: String,
      desc: String,
    },
  },
});
</script>

<style lang="scss" scoped>
.storyDesc {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  font-size: 0.65rem;
  text-align: center;
  color: #fff;
  direction: rtl;
  padding: 0 6px;
}

@media (max-width: 1000px) {
  .storyDesc {
    color: #000;
  }
}
</style>
